import Background from "./_background";
import LoginForm from "./_LoginForm";
import LoginText from "./_LoginText";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/slices/languageSlice";

const LoginPage = () => {
  return (
    <div className="w-screen h-screen relative">
      <Background />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5/6 md:w-3/6 lg:w-2/6 space-y-3">
        <LoginForm />
        <LoginText />
      </div>
    </div>
  );
};

export default LoginPage;
